{
  "Accessibility menu": "เมนูการช่วยการเข้าถึง",
  "Close": "ปิด",
  "Content adjustments": "การปรับเนื้อหา",
  "Navigation adjustments": "การปรับการนำทาง",
  "Adjust Font Size": "ปรับขนาดตัวอักษร",
  "Highlight Title": "เน้นหัวเรื่อง",
  "Highlight Links": "เน้นลิงก์",
  "Readable Font": "แบบอักษรที่อ่านง่าย",
  "Colour adjustments": "การปรับสี",
  "Dark Contrast": "ความเปรียบต่างเข้ม",
  "Light Contrast": "ความเปรียบต่างสว่าง",
  "High Contrast": "ความเปรียบต่างสูง",
  "High Saturation": "ความอิ่มตัวของสีสูง",
  "Low Saturation": "ความอิ่มตัวของสีต่ำ",
  "Monochrome": "โมโนโครม",
  "Tools": "เครื่องมือ",
  "Reading Guide": "คู่มือการอ่าน",
  "Big Cursor": "เคอร์เซอร์ขนาดใหญ่",
  "Increase Font Size": "เพิ่มขนาดตัวอักษร",
  "Decrease Font Size": "ลดขนาดตัวอักษร",
  "Letter Spacing": "ระยะห่างระหว่างตัวอักษร",
  "Line Height": "ความสูงของบรรทัด",
  "Font Weight": "น้ำหนักตัวอักษร",
  "Dyslexia Font": "แบบอักษรสำหรับดิสเล็กเซีย",
  "Language": "ภาษา",
  "Accessibility widget": "เปิดเมนูการช่วยการเข้าถึง",
  "Accessibility Profiles": "โปรไฟล์การช่วยการเข้าถึง",
  "Cognitive Disability": "ความบกพร่องทางสติปัญญา",
  "Seizure Safe": "ปลอดภัยสำหรับโรคลมชัก",
  "Accessibility statement": "คำแถลงการช่วยการเข้าถึง",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "หยุดการเคลื่อนไหว",
  "Reset all settings": "รีเซ็ตการตั้งค่า",
  "Shortcut:": "Shortcut:"
}
